'use client'

import React, { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useGtm, useAuth, useAddToHomeScreen } from '@/hooks'
import { GTM_EVENT } from '@/interfaces/gtm'
import { logger } from '@/lib'

const GTMPageView: React.FC = () => {
  const { sendDataToGTM } = useGtm()
  const pathname = usePathname()
  const { registrantId } = useAuth()
  const { isStandAlone } = useAddToHomeScreen()

  useEffect(() => {
    try {
      sendDataToGTM({ event: GTM_EVENT.PAGE_VIEW, registrantId: registrantId ?? undefined, isStandalone: isStandAlone })
    } catch (e) {
      logger.error('Caught GTM error', e as string)
    }
  }, [pathname, registrantId, isStandAlone])

  return null
}

export default GTMPageView
